export default __webpack_public_path__ + "static/media/arrow_up.1f6181eb.svg";